import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfileGuard } from 'src/app/guards/profile.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('src/app/modules/init-app/init-app.module').then(m => m.InitAppModule),
  },
  {
    path: 'domicilio',
    loadChildren: () => import('src/app/modules/choose-store/choose-store.module').then(m => m.ChooseStoreModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('src/app/modules/menu-store/menu-store.module').then(m => m.MenuStoreModule)
  },
  // {
  //   path: 'reservar-en-tienda',
  //   loadChildren: () => import('src/app/modules/choose-reservation/choose-reservation.module').then(m => m.ChooseReservationModule)
  // },
  {
    path: 'reservar-en-tienda',
    loadChildren: () => import('src/app/modules/reservation-in-store-not-3d/reservation-in-store-not-3d.module').then(m => m.ReservationInStoreNot3dModule)
  },
  {
    path: 'comer-en-tienda',
    loadChildren: () => import('src/app/modules/reservation-in-store/reservation-in-store.module').then(m => m.ReservationInStoreModule)
  },
  {
    path: 'recoger-en-tienda',
    loadChildren: () => import('src/app/modules/delivery-in-store/delivery-in-store.module').then(m => m.DeliveryInStoreModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('src/app/modules/checkout/checkout.module').then(m => m.CheckoutModule),
    canActivate: [ProfileGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'profile',
    loadChildren: () => import('src/app/modules/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [ProfileGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'rastreo',
    loadChildren: () => import('src/app/modules/tracker/tracker.module').then(m => m.TrackerModule),
    canActivate: [ProfileGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'ubicacion',
    loadChildren: () => import('src/app/modules/choose-location/choose-location.module').then(m => m.ChooseLocationModule),
    // canActivate: [ProfileGuard],
    runGuardsAndResolvers: 'always'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class MainRoutingModule { }
